module.exports = __webpack_public_path__ + "img/use_human_red_3.4011594f.png";